import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'TICKETS',
    itemActionName: 'TICKET',
});
